module.exports = __webpack_public_path__ + "img/additional-prams-icon.ae9f77e8.svg";